import { generateSearchParams } from '@/utils/generateSearchParams';
import { request } from '@/utils/request';
import { ResponseBasis } from '@/api/api.types';
import { LegalDocument, PatientInfoItem, PatientsInfoOptions } from '@/api/patient/patient.types';

export async function getPatientsInfoList(options: PatientsInfoOptions) {
  const searchParams = generateSearchParams(options);
  return request<ResponseBasis<PatientInfoItem>>(`/patient/patients_info/?${searchParams.toString()}`);
}

export async function getPatientsLegalDocumentsList(options: PatientsInfoOptions) {
  const searchParams = generateSearchParams(options);
  return request<ResponseBasis<LegalDocument>>(`/patient/legal_documents/?${searchParams.toString()}`);
}